export class GetSoilIdByNameUseCase {
  constructor(repository) {
    this.repository = repository
  }
  async execute(name) {
    const resp= await this.repository.getSoiIdByName(name)

    return resp
  }
}
